"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltip = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var core_1 = require("../../../../../../shared/core");
var ChartTooltip_styled_1 = require("./ChartTooltip.styled");
var utils_1 = require("./utils");
var ChartTooltip = function (_a) {
    var children = _a.children, visible = _a.visible, scrollRef = _a.scrollRef, setRef = _a.setRef, rest = __rest(_a, ["children", "visible", "scrollRef", "setRef"]);
    var Card = (0, core_1.useComponents)().Card;
    var _b = __read((0, react_1.useState)(0), 2), position = _b[0], setPosition = _b[1];
    var tooltipRef = (0, react_1.createRef)();
    var portal = document.getElementById('chart-tooltip-portal');
    (0, react_1.useEffect)(function () {
        if (visible && tooltipRef.current && scrollRef.current && setRef.current) {
            setPosition((0, utils_1.getTooltipPosition)(tooltipRef.current, scrollRef.current, setRef.current));
        }
        // We only wanna do this when the tooltip is shows, not when the other deps change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
    return visible && portal
        ? (0, react_dom_1.createPortal)(react_1.default.createElement(ChartTooltip_styled_1.StyledTooltip, __assign({ "data-testid": "chart-tooltip", "aria-hidden": "true", as: Card, ref: tooltipRef, style: { left: position } }, rest), children), portal)
        : null;
};
exports.ChartTooltip = ChartTooltip;
